import React from "react";
import Layout from "../../layout";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Box, CardContent, Typography } from "@mui/material";
import { useGetFindingDetail } from "../../hooks/findings";
import { useParams } from "react-router-dom";
import ReactJson from "react-json-view";

const FindingJsonViewerPage = () => {
  let { event_id } = useParams<{ event_id: string }>() || "";

  if (event_id == undefined) event_id = "";

  const {
    data: findingData = [],
    isError: isLoadingFindingsError,
    isFetching: isFetchingFindings,
    isLoading: isLoadingFindings,
  } = useGetFindingDetail({ event_id });

  let fetchedFinding = {
    details: "{}",
    notes: "",
    event_id: "",
    status: "Unknown",
  };
  if (findingData.length > 0) {
    fetchedFinding = findingData[0];
  }

  let details = fetchedFinding.details;
  let json_data = JSON.parse(details);

  return (
    <Layout pageTitle="Security Finding Detail" parentUrl="" parentPageName="">
      <Grid item xs={6}>
        <Card>
          <Box sx={{ mt: 0.2, textAlign: "end", backgroundColor: "grey.100" }}>
            <Typography sx={{ padding: "1rem", fontWeight: 700 }}>
              Alerts {fetchedFinding.event_id}
            </Typography>
          </Box>
          <Box>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{
                    lineHeight: "1em",
                    padding: 2,
                    border: 2,
                    borderColor: "divider",
                    borderRadius: 3,
                    overflow: "wrap",
                  }}
                >
                  <pre className="p-4 text-sm">
                    <h3>Status</h3>
                    {fetchedFinding.status}
                  </pre>
                </Typography>
              </CardContent>

              <CardContent>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{
                    lineHeight: "1em",
                    padding: 2,
                    border: 2,
                    borderColor: "divider",
                    borderRadius: 3,
                    overflow: "wrap",
                  }}
                >
                  <pre className="p-4 text-sm">
                    <h3>Notes</h3>
                    {fetchedFinding.notes}
                  </pre>
                </Typography>
              </CardContent>

              <CardContent sx={{}}>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{
                    lineHeight: "1em",
                    padding: 2,
                    border: 2,
                    borderColor: "divider",
                    borderRadius: 3,
                    overflow: "wrap",
                  }}
                >
                  <ReactJson theme={"apathy"} indentWidth={8} src={json_data} />
                  {/* for all themes see: https://mac-s-g.github.io/react-json-view/demo/dist/ */}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Card>
      </Grid>
    </Layout>
  );
};

export default FindingJsonViewerPage;
